import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Paper from '@material-ui/core/Paper';

import DetailsCard from '../../components/DetailsCard/DetailsCard';

import {
  claimAgent,
  counselForDebtor,
  court,
  usTrustee,
} from '@selectors/caseDetails';

import './DetailsList.scss';

const DetailsList = ({
  claimAgent,
  counselForDebtor,
  court,
  usTrustee,
}) => (
  <div className="details-list">
    {court && (
      <div className="details-list__card-wrapper">
        <Paper className="details-list__card">
          <DetailsCard
            address={court.address}
            link={court.url}
            subtitle={court.name}
            title="Court"
          >
            {court.judge && (
              <div>
                <span className="details-list__judge-information-title">
                  Judge:
                </span>
                {` ${court.judge}`}
              </div>
            )}
          </DetailsCard>
        </Paper>
      </div>
    )}
    {usTrustee && (
      <div className="details-list__card-wrapper">
        <Paper className="details-list__card">
          <DetailsCard
            address={usTrustee.address}
            link={usTrustee.url}
            subtitle={usTrustee.name}
            title="U.S. Trustee"
          />
        </Paper>
      </div>
    )}
    {counselForDebtor && (
      <div className="details-list__card-wrapper">
        <Paper className="details-list__card">
          <DetailsCard
            address={counselForDebtor.address}
            link={counselForDebtor.url}
            subtitle={counselForDebtor.name}
            title="Counsel for the debtor"
          />
        </Paper>
      </div>
    )}
    {claimAgent && (
      <div className="details-list__card-wrapper">
        <Paper className="details-list__card">
          <DetailsCard
            address={claimAgent.address}
            link={claimAgent.url}
            subtitle={claimAgent.name}
            title="Claims agent"
          />
        </Paper>
      </div>
    )}
  </div>
);

DetailsList.propTypes = {
  claimAgent: PropTypes.shape({
    address: PropTypes.object,
    name: PropTypes.string,
    url: PropTypes.string,
  }),
  counselForDebtor: PropTypes.shape({
    address: PropTypes.object,
    name: PropTypes.string,
    url: PropTypes.string,
  }),
  court: PropTypes.shape({
    address: PropTypes.object,
    judge: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
  }),
  usTrustee: PropTypes.shape({
    address: PropTypes.object,
    name: PropTypes.string,
    url: PropTypes.string,
  }),
};

DetailsList.defaultProps = {
  claimAgent: {},
  counselForDebtor: {},
  court: {},
  usTrustee: {},
};

const mapStateToProps = state => ({
  claimAgent: claimAgent(state),
  counselForDebtor: counselForDebtor(state),
  court: court(state),
  usTrustee: usTrustee(state),
});

export default connect(mapStateToProps)(DetailsList);



// WEBPACK FOOTER //
// ./src/routes/Case/Details/containers/DetailsList/DetailsList.js